"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = require("../SimpleModal/style");
var _AnimationWrapper = require("../AnimationWrapper");
var _animations = require("../style/animations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NonDismissibleModal = _ref => {
  let {
    children
  } = _ref;
  const modalRef = (0, _react.useRef)(null);
  const {
    AnimationWrapper,
    animationProps
  } = (0, _AnimationWrapper.useAnimation)({
    stageInAnimation: _animations.stageInCenter,
    stageOutAnimation: _animations.stageOutCenter,
    duration: 400
  });
  (0, _react.useEffect)(() => {
    modalRef.current.focus();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_style.Container, {
    role: "dialog",
    "aria-modal": "true",
    NonDismissibleModal: true
  }, /*#__PURE__*/_react.default.createElement(AnimationWrapper, Object.assign({}, animationProps), /*#__PURE__*/_react.default.createElement(_style.Modal, {
    ref: modalRef
  }, children)));
};
NonDismissibleModal.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = exports.default = NonDismissibleModal;